import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import {
  addAbonement,
  getAbonementsClient,
  getPacketsList,
  getPersonalPacket,
} from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";
import { getClientsList } from "src/store/Slices/ClientsSlice";

const EditPacket = ({
  packetModal,
  setPacketModal,
  clientInfo,
  packetInfo,
  payload,
}) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();
  dayjs.extend(customParseFormat);
  const yesterdayDate = dayjs().subtract(1, "day").format("DD.MM.YYYY");
  //STORE
  const packetsList = useSelector((state) => state.ClientsSlice.packetsList);
  // STATE
  const [datePurchased, setDatePurchased] = useState();
  const [personalPacketId, setPersonalPacketId] = useState();
  const [trainingsLeft, setTrainingsLeft] = useState();

  // FUNCTIONS
  const onClickEditPacket = () => {
    dispatch(
      getPersonalPacket({
        flag: "post",
        value: {
          id: packetInfo?.id,
          userId: clientInfo.id,
          datePurchased: datePurchased
            ? dayjs(datePurchased, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss")
            : null,
          personalPacketId: personalPacketId,
          trainingLeft: trainingsLeft, //на беке вот без "s" переменная называется
        },
      })
    ).then(() => {
      dispatch(
        getPersonalPacket({ flag: "get", value: { UserId: clientInfo?.id } })
      );
      dispatch(getClientsList(payload));
      setPacketModal(false);
    });
  };

  useEffect(() => {
    setDatePurchased(packetInfo?.datePurchased ?? dayjs());
    setPersonalPacketId(packetInfo?.personalPacketId);
    setTrainingsLeft(packetInfo?.trainingsLeft);
  }, [packetModal]);

  return (
    <CModal
      alignment="center"
      visible={packetModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setPacketModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Редактировать пакет"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Дата покупки</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY.MM.DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setDatePurchased(date);
                }}
                defaultValue={dayjs(datePurchased, dateFormatList)}
              />
            </div>
            <div>
              <Typography.Title level={5}>
                Id персонального пакета
              </Typography.Title>
              <Select
                style={{ width: "100%" }}
                options={packetsList?.data?.value}
                onChange={(value) => {
                  setPersonalPacketId(value);
                }}
                placeholder={"Выбрать"}
                value={personalPacketId}
              />
            </div>
            <div>
              <Typography.Title level={5}>Остаток тренировок</Typography.Title>
              <Input
                defaultValue=""
                type="number"
                value={trainingsLeft}
                onChange={(event) => {
                  setTrainingsLeft(parseInt(event.target.value));
                }}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setPacketModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickEditPacket} style={{ color: "#fff" }}>
          Редактировать
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default EditPacket;
